import type { ScheduleNode } from "../types.ts";
import type { DelayInfo } from "./delay.ts";

export type ColorScheme = "status" | "hierarchy";

export const HUE_COUNT = 8;

export type Tone =
	| "branch"
	| "pending"
	| "in_progress"
	| "completed"
	| "delayed"
	| "cancelled"
	| `hue-${number}`;

export function hueTone(topIndex: number): Tone {
	return `hue-${(topIndex % HUE_COUNT) + 1}`;
}

export function tone({
	node,
	isLeaf,
	delay,
	scheme,
	topIndex,
	percent,
}: {
	node: ScheduleNode;
	isLeaf: boolean;
	delay: DelayInfo;
	scheme: ColorScheme;
	topIndex: number;
	percent: number;
}): Tone {
	if (isLeaf && delay.kind === "delayed") return "delayed";
	if (scheme === "hierarchy") return hueTone(topIndex);
	if (!isLeaf) return "branch";
	if (node.status === "cancelled") return "cancelled";
	if (node.status === "completed" || percent >= 100) return "completed";
	if (node.status === "in_progress") return "in_progress";
	return "pending";
}
